import { Intent } from '@blueprintjs/core'
import * as actionTypes from 'src/constants/actionTypes'

export const createErrorToast = (message, options = {}) => ({
    type: actionTypes.TOAST_SHOW,
    message: {
        content: message,
        intent: Intent.DANGER,
        icon: 'error',
        ...options,
    },
})

export const createWarningToast = (message, options = {}) => ({
    type: actionTypes.TOAST_SHOW,
    message: {
        content: message,
        intent: Intent.WARNING,
        icon: 'warning-sign',
        ...options,
    },
})

export const createSuccessToast = (message, options = {}) => ({
    type: actionTypes.TOAST_SHOW,
    message: {
        content: message,
        intent: Intent.SUCCESS,
        icon: 'tick',
        ...options,
    },
})

export const dispatchErrorToast = (dispatch, message, options = {}) => {
    dispatch(createErrorToast(message, options))
}

export const dispatchWarningToast = (dispatch, message, options = {}) => {
    dispatch(createWarningToast(message, options))
}

export const dispatchSuccessToast = (dispatch, message, options = {}) => {
    dispatch(createSuccessToast(message, options))
}
